<div class="wrapper-content wow slideInDown" data-wow-delay="0.5s" *ngIf="social && cont">
  <div class="cea-header">
    <div class="cea-banner" magic [magicCss]="{type:'banner', background:api.getImageUrl(cont.image2) }"></div>
    <div class="cea-title">
      <div class="cea-brand">
        <img src="{{api.getImageUrl(cont.image) }}" alt="{{cont.altimage}}">
      </div>

      <h2>{{cont.title?.es}}

        <app-share [class]="'dark'" [name]="cont.title?.es"></app-share>

      </h2>

    </div>

  </div>
</div>


<app-widgets [data]="cont" *ngIf="social && cont"></app-widgets>

<div class="wrapper-content gray" *ngIf="social && cont" [hidden]="cont.webschedule.length==0">
  <div class="wrapper-header">
    <h1 class="text-center">CONOCE NUESTRAS ACTIVIDADES</h1>
  </div>
</div>
<div class="wrapper-content-fitted gray" *ngIf="social && cont">
  <div class="wwf-box" (click)="route.goTo('evento/'+card.id)" *ngFor="let card of cont.webschedule; let i = index"
    [hidden]="i>3">
    <div class="wwf-card" magic [magicCss]="{type:'square'}"
      [style.background]="'url('+api.getImageUrl(card.image)+')'">
      <div class="wwf-card--mask" role="img"
      [attr.aria-label]="card.altimage"
      [style.background]="'url('+api.getImageUrl(card.image)+')'">
      </div>
      <div class="wwf-card--body">
        <h4 class="wwf-card--title">{{card.title.es}}</h4>
        <p class="wwf-card--tag ts-color-1">{{card.date}}</p>
      </div>
      <div class="wwf-card--btn ts-background-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
          <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z" transform="translate(0 7890)"
            fill="#fff" />
        </svg>
      </div>
    </div>
  </div>
</div>

<div class="wrapper-content-fitted" *ngIf="social && cont">
  <h1 class="text-center">Como llegar al centro</h1>
  <p>{{social.Direccion}}</p>
  <div id="map" *ngIf="mapRender.mapCurrent==='contact'" style="width: 100%; height: 300px" class="map"></div>
</div>



<div class="wrapper-content" *ngIf="social && cont">
  <div class="wwf-footer--main cea ts-background-3">
    <H3 style="color:white; text-align: center;">Contáctate con el centro</H3>
    <p style="margin-bottom:0"><a href="" style="color:white" href="mailTo:{{social.Correo}}">{{social.Correo}}</a></p>
    <p style="margin-bottom:0"><a href="" style="color:white"
        href="tel:{{social.Telefono1}}">(+591){{social.Telefono1}}</a></p>
    <p style="margin-bottom:0"><a href="" style="color:white"
        href="tel:{{social.Telefono2}}">(+591){{social.Telefono2}}</a></p>
    <div class="social-box" style="padding: 20px;">
      <a class="social-icon" *ngIf="social.Twitter" href="{{social.Twitter}}" target="_blank">
        <!--twitter-->
        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51">
          <path id="twitter"
            d="M25,50A25,25,0,0,1,7.32,7.321,25,25,0,0,1,50,25.013,25,25,0,0,1,25,50ZM9.878,35.182h0a.346.346,0,0,1,.131.068,18.5,18.5,0,0,0,9.829,2.807,21.252,21.252,0,0,0,3.246-.257A17.8,17.8,0,0,0,34.06,31.64a19.156,19.156,0,0,0,4.532-12.825.57.57,0,0,1,.246-.537,13.3,13.3,0,0,0,2.727-2.784,1.057,1.057,0,0,1,.065-.1.382.382,0,0,0,.1-.283,13.277,13.277,0,0,1-3.543.932,6.491,6.491,0,0,0,2.773-3.623l-.018.014a.728.728,0,0,1-.262.162,12.345,12.345,0,0,1-3.472,1.351.766.766,0,0,1-.225.036.748.748,0,0,1-.5-.211,6.546,6.546,0,0,0-4.544-1.819,6.333,6.333,0,0,0-3.192.852,6.543,6.543,0,0,0-3.265,6.874c.029.154.021.247-.024.3a.2.2,0,0,1-.166.06.707.707,0,0,1-.124-.013c-.218-.037-.447-.06-.669-.082-.263-.026-.535-.054-.789-.1a18.666,18.666,0,0,1-11.464-6.4c-.1-.112-.172-.176-.233-.176s-.129.086-.212.245a6.752,6.752,0,0,0,1.038,7.443c.214.215.447.423.694.643.133.118.269.24.412.371a6.458,6.458,0,0,1-2.576-.711.565.565,0,0,0-.218-.07.093.093,0,0,0-.073.028c-.034.037-.044.111-.033.24A6.6,6.6,0,0,0,14.6,27.051a4.017,4.017,0,0,0,1.109.464c.143.044.291.09.442.142a3.8,3.8,0,0,1-1.4.214c-.291,0-.621-.017-1.01-.052-.079,0-.141-.008-.189-.008-.077,0-.116.01-.132.034-.028.042.007.128.076.3a6.434,6.434,0,0,0,3.133,3.495,6.589,6.589,0,0,0,2.843.711,11.832,11.832,0,0,1-2.748,1.643A14.064,14.064,0,0,1,10.9,35.215C10.566,35.215,10.221,35.2,9.878,35.182Z"
            transform="translate(0.5 0.5)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1" />
        </svg>
      </a>
      <a class="social-icon" *ngIf="social.Facebook" href="{{social.Facebook}}" target="_blank">
        <!--facebook-->
        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51.04" viewBox="0 0 51 51.04">
          <path id="facebbok"
            d="M27.162,50h0V30.661h5.482V24.643H27.162V22.7c0-1.541.212-2.411.71-2.909a2.953,2.953,0,0,1,2.261-.784,12.936,12.936,0,0,1,3.414.468l.974-5.259a18.4,18.4,0,0,0-6.194-.9,10.173,10.173,0,0,0-5.162,1.1,5.849,5.849,0,0,0-2.773,2.863,13.431,13.431,0,0,0-.776,5.294v2.067H15.479v6.018h4.136V49.555A25.309,25.309,0,0,1,5.6,40.83,25.046,25.046,0,0,1,25.035,0,24.98,24.98,0,0,1,50,25.04,25.065,25.065,0,0,1,43.372,42.06,24.677,24.677,0,0,1,27.163,50Z"
            transform="translate(0.5 0.5)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1" />
        </svg>
      </a>
      <a class="social-icon" *ngIf="social.Instagram" href="{{social.Instagram}}" target="_blank">
        <!--instagram-->
        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51">
          <path id="instagram"
            d="M24.994,50A25,25,0,0,1,7.324,7.327,25,25,0,0,1,50,25.005,25,25,0,0,1,24.994,50ZM15.067,11.518c-2.348,0-3.588,1.249-3.588,3.612V34.951c0,2.283,1.233,3.54,3.471,3.54h20a3.226,3.226,0,0,0,3.577-3.575V15.046c0-2.275-1.27-3.528-3.577-3.528Zm18.76,23.911H16.162c-1.23,0-1.585-.363-1.585-1.618q0-.718,0-1.441c0-2.751,0-5.592-.047-8.389,0-.861.214-1.111.953-1.111q.079,0,.166,0l.136.009c.55.035.827.053.953.2s.1.422.031,1.022a8.35,8.35,0,0,0,6.523,9.026,8.473,8.473,0,0,0,1.6.152,8.269,8.269,0,0,0,8.24-9.818c-.048-.237-.04-.372.026-.452s.219-.108.416-.108l.1-.007c.369-.028.661-.05.892-.05.46,0,.661.09.765.345a4.744,4.744,0,0,1,.109,1.471v9.143C35.412,35.081,35.066,35.429,33.827,35.429Zm-8.819-5.206h-.082a5.185,5.185,0,0,1-3.573-8.935,5.127,5.127,0,0,1,7.355.06,5.148,5.148,0,0,1,1.507,3.656,5.246,5.246,0,0,1-1.551,3.678A5.14,5.14,0,0,1,25.007,30.223ZM32.8,19.856c-2.656,0-2.656,0-2.656-2.654s0-2.645,2.61-2.645c2.679,0,2.679,0,2.679,2.679C35.435,19.856,35.435,19.856,32.8,19.856Z"
            transform="translate(0.5 0.5)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1" />
        </svg>
      </a>

      <a class="social-icon" *ngIf="social.Youtube" href="{{social.Youtube}}" target="_blank">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
          <defs>
            <style>
              .cls-1 {
                fill: #fff;
              }
            </style>
          </defs>
          <title>icon-youtube</title>
          <path class="cls-1" d="M35.29,45.36V32.69L47.84,39Z" />
          <path class="cls-1"
            d="M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0ZM63.15,49.6c-.63,3.79-2.54,5.57-6.38,5.71-8.72.31-17.45.36-26.18.47-2.24,0-4.5,0-6.74-.19-4.54-.31-6.63-1.9-7.07-6.41-.5-5.08-.44-10.22-.45-15.33a22.6,22.6,0,0,1,.8-5.4,5.73,5.73,0,0,1,5.59-4.67c5.9-.32,28.16-.33,33.38-.24,4.15.07,6.38,1.82,7.07,5.92A61,61,0,0,1,63.15,49.6Z" />
        </svg>
      </a>
    </div>
    <div class="wrapper-content-fitted" *ngFor="let widget of cont.websectiondata" [hidden]="widget.type != 13">
      <div class="images-pane" *ngIf="widget.websectiondataitem">
        <img src="{{api.getImageUrl(item.image)}}" alt="{{item.name}}" *ngFor="let item of widget.websectiondataitem">
      </div>
    </div>
  </div>
</div>
